const React = require('react');

const CommonTypes = require('../common/Types.jsx');
const Config = require('../utility/Config.jsx');
const Content = require('../common/Content.jsx');
const Item = require('../common/ItemV2.jsx');
const Name = require('../utility/Name.jsx');
const Token = require('../utility/Token.jsx');
const TypeConfig = require('../common/TypeConfig.jsx');
const Utilities = require('../utility/Utilities.jsx');

// #region META

function _PaymentMeta(props) {
    return <Content.Value {...props} value={props.content} />
}
const PaymentMeta = Token.withContentTokenParsing(_PaymentMeta, {}, (props, keyword, options) => {
    let data = props.record || props.data || {};
    if (data.Payments && props.index < data.Payments.length) {
        data = data.Payments[props.index];
    } else if (data.IssuedCredits && props.index < data.IssuedCredits.length) {
        data = data.IssuedCredits[props.index];
    }
    let replaceString = '';
    switch (keyword) {
        case Token.Date:
            if (!Utilities.isNullOrWhitespace(data.Date)) {
                replaceString = Token.getReplacementString(data.Date, options);
            }
            break;
        case Token.DisplayCurrency.Amount:
            if (data.ExchangeRate && data.ExchangeRate.Value != undefined) {
                replaceString = Token.getReplacementString(data.ExchangeRate.Value, options);
            }
            break;
        case Token.Payment.Amount:
            if (!Utilities.isNullOrWhitespace(data.Amount)) {
                let format;
                if (options) {
                    format = options.format;
                }
                replaceString = Utilities.Format.Currency.getDisplayString(data.Amount, format, props.data && props.data.Gallery && props.data.Gallery.Localization);
            }
            break;
        case Token.Payment.Method:
            if (!Utilities.isNullOrWhitespace(data.Method)) {
                replaceString = Token.getReplacementString(data.Method, options);
            }
            break;
        default:
            replaceString = undefined;
            break;
    }
    return replaceString;
})
const TokensPaymentMeta = (data) => [
    Token.getWrappedTokenConfig('Date', Token.Date),
    Token.getWrappedTokenConfig('Method', Token.Payment.Method),
    Token.getCurrencyTokenConfig('Amount', Utilities.Format.Currency.getFormatString(data && data.Gallery && data.Gallery.Localization), Token.Payment.Amount),
    Token.getWrappedTokenConfig('Amount (Display Currency)', Token.DisplayCurrency.Amount)
]
const TypeConfigPaymentMeta = {
    panel: {
        block: (design) => {
            const group = 'block';
            return {
                group,
                label: 'Design',
                options: [
                    {
                        display: 'Design payment meta here',
                        label: 'Payment Meta Design',
                        group,
                        name: 'design',
                        type: 'rich-text-collateral',
                        value: design
                    }
                ]
            };
        },
        style: () => TypeConfig.panel.layoutStyleV2('style', 'Layout')
    }
};

// #endregion META

// #region CONTAINER

const PaymentCreditBlocks = {
    get: (group, data) => [
        ...CommonTypes.BlocksV2.content.get(group),
        {
            id: Name.Block.PaymentCredit.Amount,
            component: PaymentMeta,
            config: {
                Block: TypeConfigPaymentMeta.panel.block(Utilities.wrapTextForEditor({ text: `{${Token.Payment.Amount}("format":"${Utilities.Format.Currency.getFormatString(data && data.Gallery && data.Gallery.Localization)}")}`, token: Token.Payment.Amount })),
                Style: TypeConfigPaymentMeta.panel.style()
            },
            display: 'Amount',
            group,
            image: ''
        },
        {
            id: Name.Block.PaymentCredit.Date,
            component: PaymentMeta,
            config: {
                Block: TypeConfigPaymentMeta.panel.block(Utilities.wrapTextForEditor({ text: `{${Token.Date}("before":"","after":"")}`, token: Token.Date })),
                Style: TypeConfigPaymentMeta.panel.style()
            },
            display: 'Date',
            group,
            image: ''
        },
        {
            id: Name.Block.PaymentCredit.Method,
            component: PaymentMeta,
            config: {
                Block: TypeConfigPaymentMeta.panel.block(Utilities.wrapTextForEditor({ text: `{${Token.Payment.Method}("before":"","after":"")}`, token: Token.Payment.Method })),
                Style: TypeConfigPaymentMeta.panel.style()
            },
            display: 'Method',
            group,
            image: ''
        }
    ]
}
const PaymentCreditContainer = Config.withBlockRendering(Item.Container.Component, PaymentCreditBlocks.get(), (props, block) => {
    if (!block.type) {
        return;
    }
    switch (block.type.value) {
        case Name.Block.Columns:
            if (block.config && block.config.Block && block.config.Block.renderHeaderOnlyFirst) {
                return { renderHeader: props.index == 0 }
            }
    }
});
const TypeConfigPaymentCreditContainer = {
    defaultDesign: (type, data) => ({
        "Config": {
            "blocks": [
                {
                    "config": {
                        "Block": {
                            "columnCount": "3",
                            "collapseIfEmpty-col1": false,
                            "alignmentHeader-col1": "tl",
                            "alignment-col1": "tl",
                            "width-col1": {
                                "unit": "%",
                                "value": "33.33"
                            },
                            "alignmentHeader-col2": "tl",
                            "alignment-col2": "tl",
                            "width-col2": {
                                "unit": "%",
                                "value": "33.33"
                            },
                            "alignmentHeader-col3": "tl",
                            "alignment-col3": "tl",
                            "width-col3": {
                                "unit": "%",
                                "value": "33.33"
                            },
                            "designHeader-col1": Utilities.wrapTextForEditor({ tag: Name.Stylesheet.Header2, text: 'Date' }),
                            "designHeader-col2": Utilities.wrapTextForEditor({ tag: Name.Stylesheet.Header2, text: 'Method' }),
                            "designHeader-col3": Utilities.wrapTextForEditor({ tag: Name.Stylesheet.Header2, text: 'Amount' }),
                            "renderHeaderOnlyFirst": true,
                            "spacing": {
                                "unit": "px",
                                "value": "10"
                            }
                        },
                        "Style": {}
                    },
                    "dataType": "layout",
                    "id": `${Name.Block.Columns}-${new Date().getTime()}`,
                    "type": {
                        "value": "columns"
                    },
                    "blocks": [
                        [
                            {
                                "config": {
                                    "Block": {
                                        "design": Utilities.wrapTextForEditor({ text: `{${Token.Date}("before":"","after":"")}`, token: Token.Date })
                                    },
                                    "Style": {}
                                },
                                "id": `${Name.Block.PaymentCredit.Date}-${new Date().getTime()}`,
                                "type": {
                                    "value": Name.Block.PaymentCredit.Date
                                }
                            }
                        ],
                        [
                            {
                                "config": {
                                    "Block": {
                                        "design": Utilities.wrapTextForEditor({ text: `{${Token.Payment.Method}("before":"","after":"")}`, token: Token.Payment.Method })
                                    },
                                    "Style": {}
                                },
                                "id": `${Name.Block.PaymentCredit.Method}-${new Date().getTime()}`,
                                "type": {
                                    "value": Name.Block.PaymentCredit.Method
                                }
                            }
                        ],
                        [
                            {
                                "config": {
                                    "Block": {
                                        "design": Utilities.wrapTextForEditor({ text: `{${Token.Payment.Amount}("format":"${Utilities.Format.Currency.getFormatString(data && data.Gallery && data.Gallery.Localization)}")}`, token: Token.Payment.Amount })
                                    },
                                    "Style": {}
                                },
                                "id": `${Name.Block.PaymentCredit.Amount}-${new Date().getTime()}`,
                                "type": {
                                    "value": Name.Block.PaymentCredit.Amount
                                }
                            }
                        ]
                    ]
                }
            ]
        },
        "Type": type
    })
}

// #endregion CONTAINER

module.exports = {
    Container: {
        Blocks: PaymentCreditBlocks,
        Component: PaymentCreditContainer,
        TypeConfig: TypeConfigPaymentCreditContainer
    },
    Meta: {
        Component: PaymentMeta,
        Tokens: TokensPaymentMeta
    }
}